// src/econ/scenarios.ts — the preset input vectors for the /scenarios page.
// `base` is the zero-AI reconciliation (INV-E1). The three named presets are
// krzy.ai's mapping of the published reference scenarios onto the five drivers
// (see data/econ/reference_scenarios.json).

import type { EconInputs } from "./types.ts";

export type EconScenarioId = "base" | "modest" | "substantial" | "extreme";

export interface EconScenario extends EconInputs {
  l: string;
}

export const ECON_SCEN: Record<EconScenarioId, EconScenario> = {
  base: { l: "No AI (baseline)", capabilities: 0, adoption: 0, autonomy: 0, productivity: 1, adjustment_months: 6, new_task_share: 0, horizon_year: 2030 },
  modest: { l: "Modest", capabilities: 0.15, adoption: 0.30, autonomy: 0.30, productivity: 1.5, adjustment_months: 6, new_task_share: 0.10, horizon_year: 2030 },
  substantial: { l: "Substantial", capabilities: 0.50, adoption: 0.40, autonomy: 0.70, productivity: 3.0, adjustment_months: 12, new_task_share: 0.05, horizon_year: 2030 },
  extreme: { l: "Extreme", capabilities: 0.95, adoption: 0.80, autonomy: 0.95, productivity: 6.0, adjustment_months: 24, new_task_share: 0.0, horizon_year: 2030 },
};

/** Inputs for a preset, without the display label. */
export function econScenarioInputs(id: EconScenarioId): EconInputs {
  const { l: _l, ...inputs } = ECON_SCEN[id];
  return inputs;
}
